import React from "react";
import { useDraggable } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";

const DraggableItem = (props) => {
  const { id, active, children, activeObject } = props;
  const { attributes, listeners, setNodeRef, transform, isDragging } =
    useDraggable({
      id,
    });

  const style = {
    cursor: isDragging ? "grabbing" : "grab",
    position: "absolute",
    left: `${activeObject?.left}px`,
    top: `${activeObject?.top}px`,
    transform: active ? `${transform} scale(1.1)` : transform,
    transform: CSS.Transform.toString(transform),
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      {children}
    </div>
  );
};

export default DraggableItem;
